import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import {useCreateClassMutation}  from '../../../../../features/authentication/classesApiSlice';
import PropTypes from 'prop-types';
import CustomToast from '../../../../../components/Toast';

const ClassCreateComponent=({handleCreate})=>{
  const [enteredName, setEnteredName] = useState('');
  const [validName, setValidName] = useState(true);
  const [createClass] = useCreateClassMutation();

  const createOnClick = async () => {
    const isValid=enteredName.length > 0;
    setValidName(isValid);
    if(!isValid)
      return;
   
    const response = await createClass(enteredName);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Name, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else if (response.data) {
      CustomToast('Class Created Successfully', 'success');
      setEnteredName('');
      localStorage.removeItem('classes');
      handleCreate(response.data);
    }
  };

  return(
    <Row className='align-items-baseline'>
      <Col className="col-md-6">
        <input
          type="text"
          className={`form-control ${!validName ? 'border-danger' : ''}`}
          value={enteredName}
          onChange={(e) => { setEnteredName(e.target.value), setValidName(e.target.value.length > 0);}}
          onBlur={()=>setValidName(true)}
          placeholder='Class Name'
        />
        {!validName && <p className='text-danger'>Please Enter Class Name.</p>}
      </Col>
      <Col className='col-md-6'>
        <div className='p-2'>
          <button className="btn btn-castleRed" onClick={createOnClick}>
                    Create New Class
          </button>
        </div>
      </Col>
    </Row>
  );
};

ClassCreateComponent.propTypes={
  handleCreate : PropTypes.func
};

export default ClassCreateComponent;